import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_post_ext_RowClass} from '../../../dbschema/bl_cms_post_ext.model';

export class InquiryExtensionContainerModel extends BaseContainerModel {
  bl_wf_issue_ext: bl_cms_post_ext_RowClass = new bl_cms_post_ext_RowClass();
}

